<template>
  <v-card>
    <div style="width: 100%; position: relative;">
      <h3 style="font-weight: 600; font-size: 18px; text-align: center; padding-top: 30px;">
        Cadastro abastecimento
      </h3>
      <v-btn
        icon
        style="position: absolute; right: 20px; top: 25px;"
        @click="closeModal"
      >
        <v-icon size="30">
          {{ icons.mdiClose }}
        </v-icon>
      </v-btn>
    </div>
    <div class="mt-10 mb-7 mx-7">
      <Separator label="Veículo abastecido" />
    </div>
    <v-form
      ref="form"
      class="mx-7"
    >
      <div
        v-if="vehicleData.car_plate"
        class="mb-6"
      >
        <h3 style="font-weight: 600; font-size: 14px;">
          Detalhes do Veículo:
        </h3>
        <div
          class="mt-2 d-flex"
          style="gap: 30px;"
        >
          <div
            class="d-flex align-start"
            style="gap: 10px;"
          >
            <v-icon>{{ icons.mdiCarHatchback }}</v-icon>
            <div>
              <h3 style="font-weight: 600; font-size: 14px;">
                Placa
              </h3>
              <span style="font-weight: 500; font-size: 13px;">
                {{ vehicleData.car_plate }}
              </span>
            </div>
          </div>
          <div
            class="d-flex align-start"
            style="gap: 10px;"
          >
            <v-icon>{{ icons.mdiCarHatchback }}</v-icon>
            <div>
              <h3 style="font-weight: 600; font-size: 14px;">
                Modelo
              </h3>
              <span style="font-weight: 500; font-size: 13px;">
                {{ vehicleData.model }}
              </span>
            </div>
          </div>
          <div
            class="d-flex align-start"
            style="gap: 10px;"
          >
            <v-icon>{{ icons.mdiTools }}</v-icon>
            <div>
              <h3 style="font-weight: 600; font-size: 14px;">
                Montadora
              </h3>
              <span style="font-weight: 500; font-size: 13px;">
                {{ vehicleData.manufacturer && vehicleData.manufacturer.name }}
              </span>
            </div>
          </div>
          <div
            class="d-flex align-start"
            style="gap: 10px;"
          >
            <v-icon>{{ icons.mdiCalendarToday }}</v-icon>
            <div>
              <h3 style="font-weight: 600; font-size: 14px;">
                Ano
              </h3>
              <div class="d-flex align-center justify-center">
                <span style="font-weight: 500; font-size: 13px;">
                  {{ vehicleData.manufacturing_year }}
                </span>
              </div>
            </div>
          </div>
          <div
            class="d-flex align-start"
            style="gap: 10px;"
          >
            <v-icon>{{ icons.mdiRoadVariant }}</v-icon>
            <div>
              <h3 style="font-weight: 600; font-size: 14px;">
                Km atual
              </h3>
              <div class="d-flex align-center justify-center">
                <span style="font-weight: 500; font-size: 13px;">
                  {{ vehicleData.actual_km || 0 }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="d-flex flex-column"
          style="gap: 16px;"
        >
          <div class="supply-box">
            <div
              class="d-flex items-center"
              style="gap: 10px;"
            >
              <span style="font-weight: 500; font-size: 16px;">Dados do abastecimento</span>
              <v-icon>{{ icons.mdiGasStationOutline }}</v-icon>
            </div>
            <div>
              <v-autocomplete
                v-model="driverId"
                class="mt-8"
                :items="driversData"
                item-text="name"
                item-value="id"
                label="Motorista"
                :rules="[rules.required]"
                outlined
                dense
                :loading="loadingDrivers"
              />
              <div
                class="d-flex"
                style="gap: 16px;"
              >
                <v-text-field
                  v-model="supplyInvoice"
                  outlined
                  :rules="hasNotInvoice ? [] : [rules.required]"
                  :disabled="hasNotInvoice"
                  dense
                  label="N° da nota"
                  style="width: 50%"
                />

                <v-switch
                  v-model="hasNotInvoice"
                  dense
                  inset
                  style="margin-top: 0px; padding-top: 9px; width: 50%;"
                  label="Nota sem numeração"
                />
              </div>
              <v-autocomplete
                v-model="fuelTypeId"
                :items="listFuelType"
                item-text="name"
                item-value="id"
                label="Combustível"
                :rules="[rules.required]"
                outlined
                dense
                :loading="loadingFuelTypes"
              />
              <div
                class="d-flex"
                style="gap: 16px;"
              >
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="supplyDateFormatted"
                      style="width: 50%"
                      label="Data"
                      :append-icon="icons.mdiCalendar"
                      :rules="[rules.required]"
                      outlined
                      dense
                      v-bind="attrs"
                      @blur="date = parseDate(supplyDateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="supplyDate"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
                <v-text-field
                  v-model="supplyPricePerLiter"
                  :rules="[rules.required]"
                  outlined
                  dense
                  style="width: 50%;"
                  label="Preço/L"
                  @input="handleAmountChange"
                />
              </div>
              <div
                class="d-flex"
                style="gap: 16px;"
              >
                <v-text-field
                  v-model="supplyAmountPerLiter"
                  :rules="[rules.required]"
                  outlined
                  dense
                  label="Abastecimento/L"
                  style="width: 50%"
                />
                <v-text-field
                  v-model="finalKm"
                  :rules="[rules.required]"
                  outlined
                  dense
                  style="width: 50%;"
                  label="Km final"
                />
              </div>
            </div>
          </div>

          <div class="summary-box">
            <div
              class="d-flex items-center flex-column"
              style="gap: 10px;"
            >
              <span style="font-weight: 600; font-size: 16px;">Km percorrido</span>
              <span style="text-align: center; font-weight: 500; font-size: 14px;">{{ kmPercorrido }}</span>
            </div>
            <div
              class="d-flex items-center flex-column"
              style="gap: 10px;"
            >
              <span style="font-weight: 600; font-size: 16px;">Km/L</span>
              <span style="text-align: center; font-weight: 500; font-size: 14px;">{{ kmPorLitro }}</span>
            </div>
            <div
              class="d-flex items-center flex-column"
              style="gap: 10px;"
            >
              <span style="font-weight: 600; font-size: 16px;">Valor pago</span>
              <span style="text-align: center; font-weight: 500; font-size: 14px;">{{ valorPagoFormatado }}</span>
            </div>
          </div>
        </div>
        <div
          class="d-flex align-center justify-center py-8"
          style="gap: 20px;"
        >
          <v-btn
            color="error"
            outlined
            @click="closeModal"
          >
            <span>CANCELAR</span>
          </v-btn>
          <v-btn
            color="info"
            :loading="isLoading"
            @click="handleRegisterSupply"
          >
            <span>SALVAR</span>
          </v-btn>
        </div>
      </div>
      <div
        v-else
        class="d-flex justify-center align-center py-8"
      >
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
        <span class="ml-4">Carregando dados do veículo...</span>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import Separator from '@/components/Separator.vue'
import axiosIns from '@/plugins/axios'
import formatters from '@/plugins/formattersMixin1'
import messages from '@/plugins/showMessageMixin'
import utilsMixin from '@/plugins/utilsMixin'
import {
  mdiCalendar,
  mdiCalendarToday,
  mdiCarHatchback,
  mdiClose,
  mdiGasStationOutline,
  mdiRoadVariant, mdiTools,
} from '@mdi/js'

export default {
  name: 'ChecklistFuelSupplyModal',
  components: {
    Separator,
  },
  mixins: [utilsMixin, messages, formatters],
  props: {
    vehicleId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      icons: {
        mdiClose, mdiCalendarToday, mdiRoadVariant, mdiTools, mdiCarHatchback, mdiGasStationOutline, mdiCalendar,
      },
      vehicleData: {},
      driversData: [],
      listFuelType: [],
      driverId: '',
      supplyInvoice: '',
      hasNotInvoice: false,
      fuelTypeId: '',
      supplyPricePerLiter: '',
      supplyAmountPerLiter: '',
      finalKm: '',
      supplyDate: '',
      supplyDateFormatted: '',
      menu1: false,
      isLoading: false,
      loadingDrivers: false,
      loadingFuelTypes: false,
    }
  },
  computed: {
    kmPercorrido() {
      const startKm = (this.vehicleData && this.vehicleData.actual_km) || 0
      const endKm = parseFloat(this.finalKm) || 0
      const diff = endKm - startKm

      return diff > 0 ? diff : 0
    },
    kmPorLitro() {
      const litros = parseFloat(this.supplyAmountPerLiter) || 0
      if (litros === 0) return 0

      return (this.kmPercorrido / litros).toFixed(2)
    },
    valorPago() {
      const litros = parseFloat(this.supplyAmountPerLiter) || 0
      const precoPorLitro = parseFloat(
        (this.supplyPricePerLiter || '').replace(/[^\d,]/g, '').replace(',', '.'),
      ) || 0

      return (litros * precoPorLitro).toFixed(2)
    },
    valorPagoFormatado() {
      return this.valorPago
        ? `R$ ${parseFloat(this.valorPago).toLocaleString('pt-BR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
        : 'R$ 0,00'
    },
  },
  watch: {
    hasNotInvoice() {
      if (this.hasNotInvoice) {
        this.supplyInvoice = ''
      }
    },
    supplyDate() {
      this.supplyDateFormatted = this.formatDate(this.supplyDate)
    },
  },
  async mounted() {
    await this.loadVehicleData()
    await this.handleGetDriversList()
    await this.loadFuelTypesData()
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    async loadVehicleData() {
      try {
        const response = await axiosIns.get(`/api/v1/transport/vehicles/find/${this.vehicleId}`)
        this.vehicleData = response.data.data
      } catch (error) {
        console.error('Erro ao carregar dados do veículo:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro!',
          text: 'Erro ao carregar dados do veículo!',
          showConfirmButton: false,
          timer: 3000,
        })
      }
    },
    async handleGetDriversList() {
      try {
        const { data } = await axiosIns.get('/api/v1/records/user/get_available_drivers')

        this.driversData = (data.data || []).map(driver => ({
          ...driver,
          id: driver.user_id || driver.id,
        }))
      } catch (error) {
        console.error('Erro ao buscar lista de motoristas:', error)
        this.driversData = []
      }
    },
    async loadFuelTypesData() {
      try {
        this.loadingFuelTypes = true
        const response = await axiosIns.get('/api/v1/transport/tools/vehicles/fuel_type/available')
        this.listFuelType = response.data.data
      } catch (error) {
        console.error('Erro ao carregar tipos de combustível:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro!',
          text: 'Erro ao carregar tipos de combustível!',
          showConfirmButton: false,
          timer: 3000,
        })
      } finally {
        this.loadingFuelTypes = false
      }
    },
    handleAmountChange(event) {
      this.supplyPricePerLiter = this.formatCurrency(event)
    },
    formatDate(date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')

      return `${day}/${month}/${year}`
    },
    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month}-${day}`
    },
    async handleRegisterSupply() {
      const isValid = this.$refs.form.validate()
      if (!isValid) return

      if (this.kmPercorrido <= 0) {
        this.$swal({
          icon: 'warning',
          title: 'Atenção!',
          text: 'O Km percorrido deve ser maior que 0!',
          showConfirmButton: false,
          timer: 3000,
        })

        return
      }

      const body = {
        vehicle_id: this.vehicleData.id,
        driver_id: this.driverId,
        invoice_number: this.supplyInvoice,
        fuel_type_id: this.fuelTypeId,
        amount_paid: this.unformatCurrency(this.valorPago),
        supply_price_per_liter: this.unformatCurrency(this.supplyPricePerLiter),
        supply_amount_per_liter: this.supplyAmountPerLiter,
        date: this.supplyDate,
        final_km: this.finalKm,
      }
      try {
        this.isLoading = true
        await axiosIns.post('/api/v1/transport/vehicles_supplies/store', body)
        this.$swal({
          icon: 'success',
          title: 'Sucesso!',
          text: 'Abastecimento registrado com sucesso!',
          showConfirmButton: false,
          timer: 3000,
        })
        this.$emit('save', body)
        this.$emit('close')
      } catch (error) {
        console.error('Erro ao registrar abastecimento:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro!',
          text: 'Ocorreu um erro ao salvar informações!',
          showConfirmButton: false,
          timer: 3000,
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.supply-box {
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  background: #3B355A;
  min-height: 350px;
  width: 100%;
  border-radius: 10px;
  padding: 16px;
}
.summary-box {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 71px;
  background: #3B355A;
  min-height: 75px;
  width: 100%;
  border-radius: 10px;
  padding: 16px;
}
</style>
